// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"620":"7248c56b","659":"d5e80837"}[chunkId] + ".chunk.js";
};